import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface GameConfigurationPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
    }
}

export class GameConfigurationPage extends PageBase<GameConfigurationPageOptions> {

    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;

    constructor(options: GameConfigurationPageOptions) {
        super(options);

        this._tableId = "tableGameConfigurations";
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Game',
            autoWidth: true,
            columns: [
                {
                    data: 'Game',
                    className: "bold"
                },
                {
                    data: "CustomerOperation",
                    sortable: false
                },
                {
                    data: "Currencies",
                    sortable: false
                },
            ]
        };
    }

    init(): void {
        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        this._table = new Datatable(this._tableId, this._tableOptions);

    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ProgressiveBonuses/GameConfigurationPage.ts
 **/